export const googleAutocomplete = async (text) => new Promise((resolve, reject) => {
  console.log('text', text);
  if (!text) {
    return reject('Need valid text input');
  }

  // for use in things like GatsbyJS where the html is generated first
  if (typeof window === 'undefined') {
    return reject('Need valid window object');
  }

  try {
    const center = { lat: 37.7749, lng: -122.4195 };
    const defaultBounds = {
      north: center.lat + 0.2,
      south: center.lat - 0.2,
      east: center.lng + 0.2,
      west: center.lng - 0.2,
    };
    new window.google.maps.places.AutocompleteService().getPlacePredictions(
      {
        input: text,
        fields: ['address_components', 'geometry', 'icon', 'name'],
        componentRestrictions: { country: 'us' },
      },
      resolve,
    );
  } catch (e) {
    reject(e);
  }
});
